import React from "react";
import {
  Typography,
  Divider,
} from "@mui/material";
import Abel from "../images/Abel.png"
import Tait from "../images/Tait.png"
import Roden from "../images/Roden.png"

export default function Article2(props: any) {

  return (
    <div>
      <title>"Who'd We Get?" - A Recap of the Minnesota Twins' Trade Deadline (ft. Nathan Skidmore of The Dishwasher)</title>
      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          color: "#000000",
          textAlign: "center",
          fontSize: props.isDesktop ? "34pt" : "20pt",
        }}
      >
        "Who'd We Get?" - A Recap of the Minnesota Twins' Trade Deadline (ft. Nathan Skidmore of The Dishwasher)
      </Typography>
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          fontSize: props.isDesktop ? "18pt" : "14pt",
        }}
      >
        By Nathan Skidmore • August 14th, 2025
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />

      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        The Twins were the surprise main characters of this year's deadline. Having fallen 12 games back in the division with six teams standing between them and the last Wild Card spot, it was assumed that they would be sellers. Some of their big-name players like Joe Ryan and Jhoan Duran were floating in rumors, but nobody foresaw the complete firesale of controllable players that the Twins completed on Thursday.
        <br /><br />
        The Twins' deadline is difficult to parse. On one hand, they did very well in most of their trades, and out of all the teams active at the deadline, they probably got the most future value out of anyone. But on the other hand, it’s disappointing that this Twins core—that this time last year was the defending division champs and 11 games over .500—had to be torn apart like this.
        <br /><br />
        Anyway, we’re not here today to talk about how it all went wrong; we’re here to talk about what the Twins got from all these crazy trades.
        <br /><br />
      </Typography>

      {/* Duran Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Phillies Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>RHP Jhoan Duran</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            RHP <a href="/player/690953" style={{ color: "#0d6efd", textDecoration: "none" }}>Mick Abel</a> (PHI #6, Top 100 #93),<br />
            C <a href="/player/806953" style={{ color: "#0d6efd", textDecoration: "none" }}>Eduardo Tait</a> (PHI #4, Top 100 #56)
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        RHP Mick Abel
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        The closer trade market shaped up beautifully for the Twins at this deadline. In the weeks leading up to the deadline, Emmanuel Clase got suspended for allegedly gambling, and Felix Bautista hit the IL. Suddenly, Jhoan Duran was the clear-cut best closer on the market.
        <br /><br />
        I imagine GMs around the league dream of a day where Dave Dombrowski is determined to fill a hole on his roster and they have the missing piece. That's exactly the situation the Twins found themselves in, and they took full advantage. Getting two top-100 prospects at starting pitcher and catcher in exchange for even a top reliever is great work.
        <br /><br />
        Mick Abel was a first-round pick out of high school back in 2020. His Major League career got off to a great start through four games but took a sharp turn in starts five and six before he got sent back down to Triple-A. I wouldn’t be too concerned about this; getting roughed up by veteran teams like the Padres and Mets is pretty normal growing pains for a young pitcher making the jump from Triple-A. But those are the teams the Phillies are likely to run into in the playoffs, which explains why Duran was a better roster fit for them than Abel.
        <br /><br />
        The Twins should be able to give Abel the runway he needs to develop into a solid starting pitcher. When they acquired Joe Ryan a few years ago, he was a former top pitching prospect who the Rays couldn’t figure out, and now he’s among the best pitchers in the league.
        <br /><br />
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Abel}
            alt="Mick Abel pitch metrics"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>
        As far as what Abel brings to the table (or should I say Tabel, hehehe), he has a five-pitch mix, and according to psStuff+, all those pitches are average to above average.
        <br /><br />
        Righties get a four-seam, slider, and sinker mix, and lefties see four-seam, curveball, and changeup. All of these pitches play well in the minors, but in the big leagues, the slider and curveball did well while the fastball got hit around.
        <br /><br />
        As you can see from his savant profile, he’s always had some trouble getting hit hard, but he made it work in the minors by getting hitters to chase and swing and miss. That’s what he struggled to do in his first stint in the majors. If the Twins can get him to miss bats at the Major League level, he’ll be a very effective middle-of-the-rotation starter. But if the swing-and-miss struggles continue, he still has a pretty high floor as a back-of-the-rotation guy.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        C Eduardo Tait
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Tait}
            alt="Eduardo Tait"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>
        Eduardo Tait might be the real prize of the Duran trade. He’s just 18 years old, so it’ll be a few years before he’s ready to help the Major League team. Based on the aggressiveness of their teardown, that might be for the best.
        <br /><br />
        Tait’s savant page tells a story. Here is a guy who gets in the batter's box ready to swing, and that approach has worked well for him. He hits the ball hard, he hits it in the air, he hits it with the right part of the bat, and he gets enough contact that the swinging isn’t resulting in untenable strikeout issues like it would for most prospects.
        <br /><br />
        Even though it is working for him, the approach could use some work, and I’m sure coaches are talking to him about it. But everything else about Tait screams major league impact bat, and if he can stick at catcher, it would make him one of the most valuable prospects in all of baseball. I predict in the next two years he’ll be a consensus top-ten prospect.
        <br /><br />
      </Typography>

      {/* Bader Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Phillies Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>OF Harrison Bader</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            OF Hendry Mendez (PHI #12),<br />
            RHP Geremy Villoria (DSL)
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        OF Hendry Mendez
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        I don’t think the Twins signed Bader this offseason with the intention of flipping him at the deadline, but if they did, that plan went about as well as you could have hoped. Despite the underlying numbers looking the same or worse than they always have, Bader's offensive output has been the best it’s been in years, and the Twins got multiple prospects back for him.
        <br /><br />
        Hendry Mendez has been steadily improving as he’s moved up in the minors. How often do you see that?
        <br /><br />
        .244/.357/.318 slashline his first season in A ball (not overly impressive)<br />
        .284/.386/.391 last season in A+ (an improvement for sure but nothing crazy)<br />
        .300/.379/.450 this year in AA (I’m noticing)
        <br /><br />
        Clearly something of a developmental success for the Phillies, especially in the slugging department where he’s gone from no slug to very promising in just a few years, and he’s still on an upward trajectory. In future updates to prospect rankings, I expect that he will be someone that makes a big jump.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        RHP Geremy Villoria
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Geremy Villoria was signed by the Phillies out of Venezuela earlier this year. It is genuinely shocking to open someone’s page on milb.com and see that they are 16 years old; seriously, the site should have a trigger warning. I feel like I’ve been exposed to a flash bang.
        <br /><br />
        I’ll be honest, I don’t love that it’s even possible to trade a 16-year-old, and I feel silly writing about what a 16-year-old could be in 5-7 years. But as long as that is how the system works, it is good business to try to get these absurdly young prospects thrown into deals to see if you can hit the lottery.
        <br /><br />
        When Villoria is in contention for the Cy Young in 2036, we’ll all come back and talk about how crazy it was that the Phillies traded him for three months of Harrison Bader.
        <br /><br />
      </Typography>

      {/* Varland/France Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Blue Jays Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>RHP Louis Varland, 1B Ty France</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            LHP <a href="/player/696070" style={{ color: "#0d6efd", textDecoration: "none" }}>Kendry Rojas</a> (TOR #6),<br />
            OF <a href="/player/702176" style={{ color: "#0d6efd", textDecoration: "none" }}>Alan Roden</a>
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        LHP Kendry Rojas
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Louis Varland was not the best player the Twins traded, but he was the Twins player I was most surprised to see get moved. Varland was having his breakout season with the Twins and wasn’t set to be a free agent until 2031, which—if you’re counting at home—is a long ways away.
        <br /><br />
        You don’t see a ton of good relievers traded with 4+ years of control because usually you can get about the same amount back for a good reliever whether they have 1.5 years or 3.5. Although this deadline, we saw Mason Miller and Louis Varland both traded, so maybe the models are telling teams it’s a good move, or maybe AJ Preller and Ross Atkins lost their minds.
        <br /><br />
        Whatever the reason was, the Twins got two very interesting players who will both be with the major league team in 2026.
        <br /><br />
        Kendry Rojas has an ugly Savant page, but for context, all the data we have on him is from one Triple-A start just last week. It didn’t go well.
        <br /><br />
        Rojas has been a fast riser this minor league season. He ended last year performing well in High-A and was set to start this season in Double-A but was injured in April and didn’t finish rehabbing until July. In July, he made four starts and struck out 30 while only walking two, which impressed enough that the Blue Jays promoted him to Triple-A the week before the trade deadline.
        <br /><br />
        Looking at Rojas’ arsenal, it stands out that he uses such an even balance of pitches, and according to psStuff+, all his pitches are above average with the sinker coming in as well above average.
        <br /><br />
        With this kind of stuff, you wouldn’t be surprised if Rojas struggled with command, but he doesn't. One of his defining traits all through the minors has been the K/BB ratio. If his stuff was worse, I’d be worried about him being in the zone too much, but with the swing and miss he can generate, he should be fine pounding the zone the way he has all year, although he might have to learn to be cautious with major leaguers at the plate.
        <br /><br />
        Rojas won’t be ready to take on a starting role by opening day, but I would expect him to make his debut around this time next year.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        OF Alan Roden
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Roden}
            alt="Alan Roden"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>
        Alan Roden has experienced what a lot of high-performing Triple-A hitters have experienced in recent years: Major league pitching is a lot better than minor league pitching.
        <br /><br />
        He has split his time between the big leagues and Triple-A this season. In Triple-A he’s a monster, and in the big leagues he’s a mouse. For some guys, that’s just normal growing pains, and for some guys, that’s just who they are forever. So which is it with Alan Roden?
        <br /><br />
        Roden has some good qualities that could translate well to the majors eventually. He’s very contact-oriented and very difficult to strike out, and in a league where—at least this year—the balls are dragging and power is down, that can play. We’ve seen players with similar profiles make a name for themselves bucking the exit velo/hard contact trend.
        <br /><br />
        The issue that I can see is that he feasts on fastballs and struggles against offspeed pitching. In the minors, you can get away with that, but in the majors, if word gets out you can’t hit offspeed, you’re going to see a ton of offspeed until you prove them wrong.
        <br /><br />
        If Roden can prove them wrong, he can be a starting-level outfielder. If not, he’ll just be a fourth-outfielder type.
        <br /><br />
      </Typography>

      {/* Coulombe Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Rangers Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>LHP Danny Coulombe</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            LHP Garrett Horn (A+)
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        LHP Garrett Horn
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Danny Coulombe is the man, so it’s too bad Minnesotans won’t get to watch him play baseball for the rest of 2025. But turning a rental reliever into a potential starting pitcher is good GM work.
        <br /><br />
        Garrett Horn was drafted just last year in the sixth round by the Rangers. In his first minor league season, he’s been solid with a sub-3 ERA across rookie ball and low-A. What has stood out so far is that he’s been living in the zone with 34 Ks to 6 BBs in his career, which you love to see. A-ball hitters have had a bit more luck getting the bat on the ball than rookie ball hitters, but it wouldn’t be fair to expect Horn to hold opposing hitters to a .095 batting average for his entire career.
        <br /><br />
      </Typography>

      {/* Jax Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Rays Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>RHP Griffin Jax</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            RHP <a href="/player/671737" style={{ color: "#0d6efd", textDecoration: "none" }}>Taj Bradley</a>
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        RHP Taj Bradley
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        This was another surprising trade on both sides. It’s a rare proven major leaguer with multiple years of control for proven major leaguer trade.
        <br /><br />
        Bradley is a former top pitching prospect who had been solid—although perhaps a bit underwhelming considering the hype—in his first few seasons. Then almost out of nowhere, the Rays demoted him to Triple-A and began aggressively shopping him at the trade deadline, where they found a match in Minnesota, who was aggressively shopping their entire bullpen.
        <br /><br />
        I love this trade for Minnesota. How often does a 24-year-old starting pitcher with the high ceiling and high floor of Taj Bradley, with four seasons of control, become available for the price of a single reliever? There are ranked prospects in A-ball older than Taj Bradley.
        <br /><br />
        If the Twins can unlock Bradley’s potential, they’ve got a top-of-the-rotation pitcher. If he just is what he’s been, they’ve got a back-of-the-rotation, mid-4 ERA type pitcher. Normally, to get that kind of upside plus control, you have to trade for a prospect that has no major league track record, but with Bradley, you get it all.
        <br /><br />
        He’s got enough team control that he could be on the Twins until they’re good again, or they could get a career year out of him anytime in the next three seasons and flip him for a prospects haul. However you slice it, it's a good deal for the Twins.
        <br /><br />
        Jax is a really good reliever. If the Twins had held onto him and made him the closer after Duran’s departure, maybe he could have been worth even more. So there is an opportunity cost, but I think the opportunity to trade for a pitcher that has an MLB track record and untapped potential is rare enough it merits passing up what you could get for Jax next year.
        <br /><br />
        Bradley’s numbers on the season aren’t great, but playing most of his games in a spring training facility certainly didn’t help. You can see his ERA is almost a full run higher than his xERA. Additionally, he had finally somewhat solved the hard-hit% and barrel% problems that had plagued him in his first few seasons in Tampa.
        <br /><br />
        If Bradley could combine the whiff and chase numbers from 2024 with the contact numbers from 2025, you’d be looking at the pitcher he was always supposed to be, and now the Twins have four seasons to help him figure that out.
        <br /><br />
        We have Savant data on Bradley, although it’s only from one start this season, so similar to Kendry Rojas, I wouldn’t put too much stock in such a small data set. But one thing I want to point out is that even though he’s a third-year big leaguer, his prospect score is still high because he’s so young.
        <br /><br />
      </Typography>

      {/* Castro Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Cubs Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>UT Willi Castro</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            RHP Sam Armstrong (AA),<br />
            RHP Ryan Gallagher (AA, CHC #8)
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        RHP Ryan Gallagher
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        The Twins continued to reinforce their minor league pitching depth with the Willi Castro trade, grabbing two Double-A starters from the Cubs.
        <br /><br />
        Ryan Gallagher was drafted just last year out of UC Santa Barbara. The Cubs started him in High-A, where he was steady. After 14 starts, they felt they had seen enough to move him up to Double-A, and that’s when the Twins swooped in and traded for him.
        <br /><br />
        He got lit up in his first start as a Wichita Wind Surge, but before that, he had been nails for his Chicago Double-A team, so we’ll attribute the struggles to jet lag.
        <br /><br />
        He doesn’t have the stuff to ever become a top-of-the-rotation starter, but with his excellent command and his collection of offspeed pitches to throw at hitters, he should be able to become a reliable mid-to-back-end-of-the-rotation starter.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        RHP Sam Armstrong
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Armstrong is repeating Double-A this year despite a strong showing at the level in 2024. I’m sure the Cubs thought they’d promote him quickly, but he scuffled a bit his second time through, posting a worse K/BB, ERA, and giving up a lot more home runs.
        <br /><br />
        Armstrong is a year older than Taj Bradley and probably tops out as a spot starter/long relief type at the major league level.
        <br /><br />
      </Typography>

      {/* Correa Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Astros Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>SS Carlos Correa</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            LHP Matt Mikulski (A+)
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        LHP Matt Mikulski
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        I know that the smart reaction to this trade is to congratulate the Twins on escaping from a contract that was likely underwater, but that’s just not how I see it.
        <br /><br />
        I am struggling to find a way to look at this trade that isn’t a spit in the face for Twins fans. I saw some people talking about how this was smart because the last few years of that contract could be ugly, and I’m here to say that it would have been totally fine if Carlos Correa had played out his entire contract in Minnesota.
        <br /><br />
        With all the trades the Twins had done at this deadline, they pretty much guaranteed that they’ll be running a payroll skeleton crew out there for the next several years. Right now, the only players under contract after this season for more than $10 million are Byron Buxton, who refuses to be traded, and Pablo Lopez, who will most likely be traded. I don’t think the Twins will be signing any major free agents in the next few years, so I am reporting early that for the next three years, the Twins payroll will be ~$100 million even with them paying $10 million a year to Correa. The difference between paying $100 million for a baseball team with no Correa and paying $120 million for a baseball team with Correa is negligible, even with a poor ownership group.
        <br /><br />
        Getting a contract off the books and saving the owners money is only valuable if it leads to those savings being reinvested in the team, and the Twins have signaled loud and clear with their deadline teardown that they’re not going to do that, at least in the immediate future. Maybe I shouldn’t speak so definitively, but I feel very confident that there won’t be a point in the next three years where the Twins hand out a big contract and everyone says, "Thank goodness they moved that Correa contract, otherwise this would not have been possible."
        <br /><br />
        The main benefit of this trade would have been to make it a little (and I want to stress "little") easier to sell the team. If that were the case where the Twins were just clearing the books so that new owners could come in and start fresh, that would be easier to swallow for Twins fans. But just this week, the Twins ownership put out a statement that they would not be selling the team. So Twins fans don’t even get the benefit of being able to hope for a brighter future with new ownership.
        <br /><br />
        I know that Correa has not been great this year, but this is kind of what he does. In 2023, he had a very similar statline, and then in 2024, he hit .310/.388/.517. Plus, he’s a really good veteran player for the Twins' young infielders to come up and learn from. Even if Correa isn’t nearly worth the $33 million a year the Twins are paying him, I believe the Twins would have gotten more value paying $30 million a year for Correa than they will from paying $10 million a year for him to play for the Astros.
        <br /><br />
        If you HAD to trade him, this return is ridiculous. I know Correa said he would only waive his no-trade clause for the Astros, so that limits your options. But I think if they had held onto him and let him play the rest of the season with the post-teardown roster, he would have been willing to waive that no-trade clause for a few more teams in the offseason, and you could have at least gotten some sort of actual prospect in return.
        <br /><br />
        All it would have cost the Twins to hold onto Correa until the offseason was $8 million. You do that, then in the offseason you offer to eat $15 million a year instead of $10 million a year, and now you’re trading Correa on a three-year, $45 million contract for his age 31-33 seasons. I think you could have gotten something decent.
        <br /><br />
      </Typography>

      {/* Paddack/Dobnak Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Tigers Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>RHP Chris Paddack, RHP Randy Dobnak</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            C <a href="/player/806992" style={{ color: "#0d6efd", textDecoration: "none" }}>Enrique Jimenez</a> (A, DET #14)
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        C Enrique Jimenez
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        I think people were surprised that the Twins got something for Chris Paddack, who has been the definition of a #5 starter that a good team would like to upgrade from (4.88 ERA and 86 ERA+ in four seasons with the Twins). So good for the Twins for turning three months of Chris Paddack and Randy Dobnak into a decent prospect.
        <br /><br />
        If you’re a young kid interested in making the big leagues, the best thing you can be is a switch-hitting catcher, which is exactly what Enrique Jimenez is. Jimenez is what you would call a high-floor, low-ceiling prospect. He is good behind the plate defensively, and his patient approach at the plate plus the switch-hitting makes him solid offensively, even if the contact skills are average and the EVs he’s put up are underwhelming.
        <br /><br />
        We do have savant data on Jimenez, but it’s just from five games, so I wouldn’t want to overanalyze such a small sample size. But one thing to watch is his pulled-in-the-air percentage, which currently rests at 0%. If he was to add more pulled-in-the-air to his game, he could sneak a few more balls over the wall and make his offensive profile much more palatable. I’ll be interested to see where that percentage lies after a full season at the level.
        <br /><br />
      </Typography>

      {/* Stewart Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Dodgers Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>RHP Brock Stewart</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Twins Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            OF <a href="/player/681546" style={{ color: "#0d6efd", textDecoration: "none" }}>James Outman</a>
          </div>
        </div>
      </div>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        OF James Outman
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Yet another trade where the Twins departed with a controllable reliever in exchange for a once-promising young player who has since lost his shine. This one was a bit more of a head-scratcher to me.
        <br /><br />
        Brock Stewart is a really good reliever, a really cool story, and after years of injuries and rehab, this year it was all coming together. Despite being 33 and having debuted in 2016, Stewart won’t reach free agency until 2028, so he’s affordable, controllable, and effective—which you think would make him either a fit to stay in Minnesota or be a valuable trade chip. That’s why I am a little bit underwhelmed by Outman being the return on this trade.
        <br /><br />
        I don’t understand the urgency to move off of Stewart. With two more years of control left, the Twins could have traded him this offseason, next trade deadline, next offseason, or the trade deadline after that, and probably gotten someone as good as James Outman at any of those points. Why do it now? It’s not like the Twins bullpen is overcrowded.
        <br /><br />
        Outman flashed as an older rookie in 2023 when he put up 3.4 WAR, slashing .248/.353/.437, played in 151 games, and finished third in Rookie of the Year voting. Those stats look great, but most of that damage was done in the first half of the season. At the end of April 2023, he was slashing .292/.376/.615, and it was pretty much all downhill from there.
        <br /><br />
        In 2024 and 2025, Outman has been just brutal at the plate and hasn’t been able to carve out a consistent role on the major league team, getting optioned and recalled every couple months. At this point, he’d been passed by several other young prospects in the org, and the Dodgers were probably relieved they could get someone as good as Stewart in exchange for Outman.
        <br /><br />
        Maybe the Twins see something in Outman and are optimistic they can get him back to who he was for a few months back in 2023. If Outman does bounce back and is a 3-4 WAR per-year player for the next few years, then this is a slam-dunk trade for the Twins. That does not seem likely; in fact, I’d say it’s more likely Outman is DFA’d by this time next year than he ever puts up more than 3 WAR in a season for the Twins.
        <br /><br />
      </Typography>

      {/* Conclusion */}
      <Typography variant="h4" style={{ color: "rgba(0, 0, 0, 1)", marginTop: "30px" }}>
        Conclusion
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        We ended on a bit of a bummer, but altogether, I really liked this deadline for the Twins, and I’m not just saying that. Before the deadline, I made a list ranking 87 starting pitching prospects that could get traded at the deadline, and the Twins acquired more of those pitchers than anyone.
        <br /><br />
        Process-wise, I think it is always smart to trade relievers at the deadline when contending teams’ desperation is at its highest. The Twins moved mostly relievers and got back prospects that play much more valuable positions like starting pitchers and catchers.
        <br /><br />
        I am intrigued at where the Twins go from here. A trade deadline teardown this intense usually signals a rebuild, but when I look at who the Twins have on their roster and farm system, I don’t think it’s out of the question that they could be good next year if they wanted to be.
        <br /><br />
        The rotation could be Ryan, Lopez, Ober, Bradley, and Abel, with Zebby Matthews, Simeon Woods-Richardson, and Kendry Rojas as depth, which is a very good pitching staff. Maybe some of those guys that got pushed from the rotation slide into the bullpen to fill in for everyone that just got traded.
        <br /><br />
        The offensive lineup currently leaves something to be desired, but their top three prospects—Walker Jenkins, Emmanuel Rodriguez, and Luke Keaschall—should all be in the majors in 2026. You shouldn’t bank on rookies, but if those guys can be okay, and the Twins get something from guys like Royce Lewis and Ryan Jeffers, and Byron Buxton stays healthy, you’ve got something. That’s a lot of ifs, though.
        <br /><br />
        If the Twins were to trade from their strong rotation, could they get major league talent to help bolster their lineup? The Red Sox were salivating for Joe Ryan at the deadline, and I imagine they’ll still be interested in the offseason. Could the Twins turn Ryan into a couple of good outfielders from the Sox? I don’t know what those negotiations look like, but it feels like the Twins have the means to make this a short rebuild.
        <br /><br />
        Inversely, they could complete the teardown in the offseason and trade Ryan, Lopez, and Ober for a bunch of minor leaguers several years away and really draw this thing out—and maybe that’s the smart thing to do.
        <br /><br />
        If you enjoyed this article, feel free to check out my blog <a href="https://thedishwasher.blog/">TheDishwasher.blog</a>.
        <br /><br />
      </Typography>
    </div>
  );
}
